var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6042 11.6103H4V4.0061H11.6042V11.6103Z",
    fill: "#001B40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 11.6103H12.3955V4.0061H19.9996V11.6103Z",
    fill: "#001B40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.604 20.0092H4V12.4051H11.604V20.0092Z",
    fill: "#001B40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 20.0092H12.3955V12.4051H19.9996V20.0092Z",
    fill: "#001B40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMicrosoft);
export default __webpack_public_path__ + "static/media/logo_microsoft.5c4e8e951ef65b2b001c6d9b60612df9.svg";
export { ForwardRef as ReactComponent };